import request from "../../../utiles/axios";

/**
 * 退出登录
 * @param {*} data
 * @returns
 */
export function loginOut(data) {
  return request({
    url: "/loginOut",
    method: "post",
    data: data,
  });
}
/**
 * 修改密码
 * @param {*} data
 * @returns
 */
 export function updatePw(data) {
  return request({
    url: "/user/updatePw",
    method: "post",
    data: data,
  });
}